"use client";

import { cn } from "@/lib/utils";

/**
 * A rotating 2+ Years badge component.
 * Uses SVG text on a path for the circular text.
 */
export const TwoYearBatch = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "relative flex items-center justify-center w-24 h-24 md:w-28 md:h-28 rounded-full bg-[#f54b00] text-white font-bold shadow-lg",
        className,
      )}
    >
      {/* Rotating outer text */}
      <div className="absolute inset-0 animate-[spin_10s_linear_infinite]">
        <svg viewBox="0 0 100 100" className="w-full h-full p-1">
          <path
            id="circlePath"
            d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
            fill="transparent"
          />
          <text className="text-[10.5px] font-bold fill-white tracking-[2px] uppercase opacity-60">
            <textPath href="#circlePath" startOffset="50%" textAnchor="middle">
              We are providing IT services
            </textPath>
          </text>
        </svg>
      </div>

      {/* Center content */}
      <div className="flex flex-col items-center justify-center z-10 leading-none pb-1">
        <span className="text-4xl md:text-2xl font-extrabold tracking-tighter">
          2+
        </span>
        <span className="text-sm md:text-base font-semibold">Years</span>
      </div>
    </div>
  );
};
